import styled from 'styled-components';
import colors from 'basic-ui-lib/constants/colors';
import { Col, Ic3Dots, Text } from 'basic-ui-lib';
import { IMediaItem } from 'modules/media/interfaces/api';
import MenuAction from 'basic-ui-lib/components/MenuTabelAction';
import ModalConfirm from 'widgets/ModalConfirm';
import EditNameModal from 'basic-ui-lib/components/Modal/EditNameModal';
import { RenderMedia } from 'basic-ui-lib/components/screen/RenderMedia';
import { useMediaMoreAction } from 'modules/media/services/hooks/useMediaMoreAction';

interface MediaCardProps {
  item: IMediaItem;
  onClick?: () => void;
  currentPath: string;
}
export const MediaCard = ({ item, onClick, currentPath }: MediaCardProps) => {
  // const modalConfirmRef = useModalConfirmRef();
  // const editNameModalRef = useRef<EditNameModalRef>(null);
  // const [, mutate] = useGetManageLibrary(true);

  // const { deleteItem } = useDeleteMediaItem({
  //   currentPath,
  // });

  // const listMenu = [
  //   {
  //     key: 'edit_name',
  //     title: 'Edit Name',
  //     icon: <IcEdit width={16} height={16} />,
  //   },
  //   {
  //     key: 'delete_media',
  //     title: 'Delete',
  //     icon: <IcTrash width={16} height={16} />,
  //   },
  // ];

  // const handleMenuClick = (item: any, record: IMediaItem) => {
  //   switch (item.key) {
  //     case 'edit_name':
  //       editNameModalRef.current?.open({ currentName: record.name, id: record.id, onFinish: handleEditName });
  //       break;
  //     case 'delete_media':
  //       handleDelete(record);
  //       break;
  //     default:
  //       break;
  //   }
  // };

  // const handleDelete = (item: IMediaItem) => {
  //   modalConfirmRef.current?.open(() => deleteItem(item), {
  //     message: 'Do you want to delete this image?',
  //   });
  // };

  // const handleEditName = async (id: string, newName: string) => {
  //   await mediaApis.renameMediaItem(id, newName);
  //   toast.success('Name updated successfully');
  //   mutate(currentPath);
  // };

  const { getListMenu, handleMenuClick, modalConfirmRef, editNameModalRef } = useMediaMoreAction({currentPath});
  return (
    <Container>
      <Content>
        <Zone onClick={onClick}>
          <MoreButton onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}>
            <MenuAction listMenu={getListMenu(item)} onClick={(menuItem) => handleMenuClick(menuItem, item)}>
              <Ic3Dots width={20} height={20} fill='#777D7C' />
            </MenuAction>
          </MoreButton>
          {/* {item.type === MediaType.VIDEO ? (
            <video src={item.url || undefined} className='media-video' muted playsInline controls />
          ) : item.type === MediaType.IMAGE ? (
            <img src={item.url || undefined} className='media-image' alt={item.name} />
          ) : null} */}
          {RenderMedia(item, 4, false)}
        </Zone>
      </Content>
      <Col gap={4} width='100%' alignItems='center'>
        <Text ellipsis content_2 medium style={{ maxWidth: '100%' }}>
          {item.name}
        </Text>
        <Text caption_3 regular color='neutral.text.3'>
          {item.size}
        </Text>
      </Col>
      <ModalConfirm ref={modalConfirmRef} />
      <EditNameModal ref={editNameModalRef} />
    </Container>
  );
};

const MoreButton = styled.div`
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, visibility 0.2s;

  width: 32px;
  height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${colors.neutral.bg[2]};

  &:hover {
    cursor: pointer;
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  &:hover {
    cursor: pointer;
  }

  &:hover ${MoreButton} {
    opacity: 1;
    visibility: visible;
  }
`;

const Content = styled.div`
  width: 100%;
  padding: 12px;
  height: 131px;
  background: ${colors.neutral.bg[1]};
  border-radius: 8px;

  &:hover {
    background: ${colors.neutral.bg[3]};
  }
`;

const Zone = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: ${colors.neutral.text[3]};
  border-radius: 4px;

  .media-video,
  .media-image {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    border-radius: 4px;
  }
`;
